import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type OrderConfirmation } from "../OrderConfirmation/types";
import { type MemberOrders } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberOrders.Api.InitRequest
  ): Promise<HttpApiResponse<MemberOrders.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/orders`, args),
  detail: (
    apiInfo: ModuleApiInfo,
    args: MemberOrders.Api.GetDetailRequest
  ): Promise<HttpApiResponse<MemberOrders.Api.GetDetailResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/orders/${args.id}`),
  downloadPdf: (apiInfo: ModuleApiInfo, id: string): Promise<any> =>
    api.download(apiInfo, `/api/site/v1/modules/member/orders/${id}/invoice`),
  createComment: (
    apiInfo: ModuleApiInfo,
    id: string,
    comment: string
  ): Promise<HttpApiResponse<OrderConfirmation.Api.CreateCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/orderConfirmation/${id}/comment`, { comment })
};
